    import React, { useState, useEffect } from "react";
    import { GetProductsData, GetCategoriesData, GetStoresData } from "../../../lib/data";
    import { getProductById } from "../../../lib/apiCalls";
    import { useParams } from "react-router-dom";
    import EditProductsUi from "../../../ui/productsUi/editProductsUi";
    import i18n from "../../../lib/i18n";

    export default function EditProducts() {

    const [categoriesData, setCategoriesData] = useState([]);
    const [storesData, setStoresData] = useState([]);
    const [productByIdData, setProductByIdData] = useState({});
    const { productId } = useParams();
    const t = i18n.t.bind(i18n);

    useEffect(() => {
        handleApi();
    }, []);

    const handleApi = async () => {
        const params = [ {"status": "sub"} ];
        try {
            const categories = await GetCategoriesData(1, params);
            const stores = await GetStoresData();
            const byId = await getProductById(productId);
            setCategoriesData([]);
            setStoresData([]);
            setProductByIdData({});
            categories.data?.map((e) => setCategoriesData((prev) => [...prev, e]));
            stores.data?.map((e) => setStoresData((prev) => [...prev, e]));
            setProductByIdData(byId.data?.data || {});
        } catch (err) {
            setCategoriesData([]);
            setStoresData([]);
            setProductByIdData({});
    }
    };


    const searchCategories = async (param) => {
        const params = [{ name: param }, {"status": "sub"}];
        if (param) {
            const res = await GetCategoriesData(1, params);
            setCategoriesData([]);
            res.data?.map((e) => setCategoriesData((prev) => [...prev, e]));
        }
    };


    const searchStores = async (param) => {
        const params = [{ name: param }];
        if (param) {
            const res = await GetStoresData(1, params);
            setStoresData([]);
            res.data?.map((e) => setStoresData((prev) => [...prev, e]));
        }
    };


    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.products")}</h1>
                <EditProductsUi
                    categoriesData={categoriesData}
                    storesData={storesData}
                    productByIdData={productByIdData}
                    searchCategories={searchCategories}
                    searchStores={searchStores}
                />
            </div>
        </div>
    );
    }